<template>
  <el-dialog
    top="15vh"
    width="800px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    @close="close">
    <div slot="title">
      {{$t('sendToCustomer.sendToCustomer')}}
      <span>{{ deptType === 'ZY' ? `(${$t('sendToCustomer.storeTypeDirect')})` : deptType === 'JM' ? `${$t('sendToCustomer.storeTypeFranchise')}` : '' }}</span>
    </div>
    <section class="dialog-box">
      <div class="address-box">
        <div class="row align-center sn-row">
          <span>{{$t('sendToCustomer.documentNo')}}</span>
          <p>{{snData.orderNo}}</p>
        </div>
        <div class="row address-row">
          <div class="row address-item">
            <div class="item-left" style="color: #0b83f3;">{{$t('sendToCustomer.sender')}}</div>
            <div class="column space-between item-right">
              <div class="name">{{send.receiverName}}</div>
              <div class="phone">{{send.phone}}</div>
              <div class="address">{{send.province + send.city + send.area + send.address}}</div>
            </div>
          </div>
          <div class="row address-item">
            <div class="row align-center item-left" style="background: rgb(255,237,235);color: red;">{{$t('sendToCustomer.receiver')}}</div>
            <div class="column space-between item-right">
              <div class="name">{{addressObj.receiverName}}</div>
              <div class="phone">{{addressObj.phone}}</div>
              <div class="address">{{addressObj.province + addressObj.city + addressObj.area + addressObj.address}}</div>
            </div>
            <div class="change-address" @click="addressVisible = true">{{snData.expressNo ? $t('sendToCustomer.changeReceiverInfo') : $t('sendToCustomer.fillReceiverInfo')}}</div>
          </div>
        </div>
      </div>

      <div style="margin: 20px 0 10px;">{{$t('sendToCustomer.contactProductCenterForHelp')}}</div>
      <div class="row align-center">
        <div style="width: 210px;text-align: right;">
          <i style="color: red;margin-right: 5px;">*</i>
          <span>{{$t('sendToCustomer.inputMethod')}}：</span>
        </div>
        <el-radio-group v-model="otherObj.orderType">
<!--          <el-radio label="1" border>{{$t('sendToCustomer.jdAutoOrder')}}</el-radio>-->
          <el-radio v-if="isHands === 'Y'" label="2" border>{{$t('sendToCustomer.manualOrder')}}</el-radio>
        </el-radio-group>
      </div>

      <template v-if="otherObj.orderType === '2'">
        <div class="row align-center" style="margin-top: 20px;">
          <div style="width: 210px;text-align: right;">
            <i style="color: red;margin-right: 5px;">*</i>
            <span>{{$t('sendToCustomer.logisticsNo')}}：</span>
          </div>
          <div class="row align-center" style="border: 1px solid #ddd;width: 400px;padding: 0 10px;border-radius: 4px;">
            <i class="iconfont icon-saoma" style="font-size: 24px;margin-right: 20px;"></i>
            <input
            type="text"
            ref="searchCode"
            :placeholder="$t('sendToCustomer.scanOrInputLogisticsNo')"
            style="border: none;outline: none;line-height: 40px;flex: 1;background: none;font-size: 16px;"
            v-model="otherObj.waybillNo"
            v-focusInput="1"/>
          </div>
        </div>
        <div class="row align-center" style="margin-top: 20px;">
          <div style="width: 210px;text-align: right;">
            <i style="color: red;margin-right: 5px;">*</i>
            <span>{{$t('sendToCustomer.expressCompany')}}：</span>
          </div>
          <el-select :placeholder="$t('sendToCustomer.pleaseSelect')" style="width: 400px;" v-model="otherObj.logisticsInfoId" filterable>
            <el-option v-for="(item, idx) in logisticsList" :key="idx" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </div>
      </template>
      <template v-if="otherObj.orderType === '1'">
        <div class="row align-center" style="margin-top: 20px;margin-bottom: 10px;">
          <span>{{$t('sendToCustomer.estimatedWeight', {weight: otherObj.weight})}}</span>
          <span>（{{$t('sendToCustomer.calcByProductWeight')}}）</span>
        </div>
        <span v-if="1===2" style="margin-left: 13px;border-radius: 4px;background: rgb(255,247,230);padding: 2px 5px;color: rgb(212,107,8);">
          {{Number(otherObj.weight) > 30 ? '当前重量>30公斤，将下单京东快运' : '当前重量<30公斤，将下京东快递'}}
        </span>
      </template>
    </section>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{$t('sendToCustomer.cancel')}}</el-button>
      <el-button type="primary" :loading="submitLoading" @click="sureBefore">{{$t('sendToCustomer.confirm')}}</el-button>
    </div>
    <el-dialog
      :title="$t('sendToCustomer.fillReceiverInfo')"
      top="15vh"
      width="500px"
      append-to-body
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :visible.sync="addressVisible"
      @close="addressVisible = false">
      <section style="margin-top: -20px;">
        <el-form inline size="small" label-position="top">
          <el-form-item required :label="$t('sendToCustomer.receiverName')">
            <el-input :placeholder="$t('sendToCustomer.pleaseInput')" style="width: 400px;" v-model="addressObj.receiverName"></el-input>
          </el-form-item>
          <el-form-item required :label="$t('sendToCustomer.phoneNumber')">
            <el-input :placeholder="$t('sendToCustomer.pleaseInput')" style="width: 400px;" v-model="addressObj.phone"></el-input>
          </el-form-item>
          <el-form-item required :label="$t('sendToCustomer.provinceCityArea')">
            <el-cascader
                :placeholder="$t('sendToCustomer.pleaseSelect')"
                style="width: 400px;"
                v-model="otherObj.ssq"
                :props="{label: 'name', children: 'nodes', value: 'name'}"
                :options="addressArray"
                @change="getSelectAddress">
            </el-cascader>
          </el-form-item>
          <el-form-item required :label="$t('sendToCustomer.detailedAddress')">
            <el-input :placeholder="$t('sendToCustomer.pleaseInput')" style="width: 400px;" v-model="addressObj.address"></el-input>
          </el-form-item>
        </el-form>
        <div style="margin: 10px 0;">
          <p style="color: #0b83f3;margin-bottom: 5px;">{{$t('sendToCustomer.autoParse')}}</p>
          <el-input v-model="otherObj.addressData" type="textarea" :rows="3" :placeholder="$t('sendToCustomer.pleaseInput')" @change="onAddressInput"></el-input>
        </div>
      </section>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addressVisible = false" type="primary">{{$t('sendToCustomer.confirm')}}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {queryDeptAddress} from "@/libs/http/modules/customer";
import AddressParse from "address-parse"
import {logisticsCompanyList, queryCityInfoList} from "@/libs/http/api";
import {getSalesOrderWeight, posSellSendVisitor} from "@/libs/http/modules/posOrder";
import {queryNegativeManualExpress} from "@/libs/http/modules/erp";
export default {
  name: 'sendGoods',
  props: {
    snData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: true,
      addressVisible: false,
      submitLoading: false,
      deptType: this.$cache.local.get('saleQuality'),
      logisticsList: [],
      isHands: '',
      addressArray: [],
      send: {
        receiverName: '',
        phone: '',
        province: '',
        city: '',
        area: '',
        address: ''
      },
      addressObj: {
        receiverName: '',
        phone: '',
        province: '',
        city: '',
        area: '',
        address: ''
      },
      otherObj: {
        orderType: '2',
        logisticsInfoId: '',
        waybillNo: '',
        addressData: '',
        weight: '0',
        ssq: []
      }
    }
  },
  created() {
    this.queryHands()
    this.getWeight()
    this.queryAddress()
    this.getAddressData()
    if(this.snData && this.snData.orderType === '2'){
      this.onAddressInput(this.snData.recipientAddress)
      this.addressObj.receiverName = this.snData.recipientName
      this.addressObj.phone = this.snData.recipientPhone
      this.otherObj.orderType = this.snData.orderType
      this.otherObj.waybillNo = this.snData.expressNo
      this.otherObj.logisticsInfoId = this.snData.logisticsId
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
      this.$emit('close')
    },
    queryHands(){
      queryNegativeManualExpress().then(res=>{
        if(res === 'Y'){
          this.isHands = res
          this.fetchCompanyList()
        }
      }).catch(error=>{})
    },
    queryAddress () {
      queryDeptAddress({
        id: this.$cache.local.get('deptId')
      }).then(data => {
        if(data){
          this.send.receiverName = data.principal
          this.send.phone = data.principalPhone
          this.send.province = data.province
          this.send.city = data.city
          this.send.area = data.area
          this.send.address = data.address
        }
      }).catch(err => { })
    },
    getAddressData () {
      queryCityInfoList().then(data => {
        this.addressArray = data.nodes
      }).catch(err => {})
    },
    getSelectAddress(e){
      this.addressObj.province = e[0]
      this.addressObj.city = e[1]
      this.addressObj.area = e[2]
    },
    onAddressInput (text) {
      const parse = AddressParse.parse(text)
      if (parse && parse.length > 0) {
        const content = parse[0]
        this.addressObj.province = content.province
        this.addressObj.city = content.city
        this.addressObj.area = content.area
        this.addressObj.address = content.details
        this.addressObj.receiverName = content.name
        this.addressObj.phone = content.mobile
        this.otherObj.ssq = [content.province, content.city, content.area]
      }
    },
    fetchCompanyList() {
      logisticsCompanyList({
        page: 1,
        pageSize: 100,
        delState: 0
      }).then(data => {
        this.logisticsList = data.items || []
      }).catch(err => {})
    },
    getWeight(){
      getSalesOrderWeight({
        id: this.snData.invoicesId
      }).then(res=>{
        if(res){
          this.otherObj.weight = (res / 1000).toFixed(2)
        }
      }).catch(err=>{})
    },

    sureBefore(){
      for(let key in this.addressObj){
        if(!this.addressObj[key]){
          return this.$message({ showClose: true, message: this.$t('sendToCustomer.pleaseFillReceiverInfo'), type: "error", duration: 2000 });
        }
      }
      let reqData = {
        ...this.addressObj,
        orderType: this.otherObj.orderType,
        invoicesId: this.snData.invoicesId
      }
      if(this.otherObj.orderType === '2'){
        if(!this.otherObj.waybillNo){
          return this.$message({ showClose: true, message: this.$t('sendToCustomer.pleaseFillLogisticsNo'), type: "error", duration: 2000 });
        }
        if(!this.otherObj.logisticsInfoId){
          return this.$message({ showClose: true, message: this.$t('sendToCustomer.pleaseSelectLogisticsCompany'), type: "error", duration: 2000 });
        }
        reqData['waybillNo'] = this.otherObj.waybillNo
        reqData['logisticsInfoId'] = this.otherObj.logisticsInfoId
      }
      if(this.snData && this.snData.expressNo){
        reqData['id'] = this.snData.id
      }
      this.submitLoading = true
      posSellSendVisitor(reqData).then(res=>{
        this.close()
        this.$emit('refresh')
        this.submitLoading = false
      }).catch(error=>{
        this.submitLoading = false
        this.$message({ showClose: true, message: error, type: "error", duration: 2000 });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-box{
  margin-top: -20px;
  .address-box{
    border: 1px solid #eee;
    .sn-row{
      background: rgb(238,241,251);
      padding: 10px;
      span{
        font-size: 16px;
        margin-right: 20px;
      }
      p{
        font-size: 24px;
        color: #0b83f3;
        font-weight: bold;
      }
    }
    .address-row{
      margin-bottom: 20px;
      .address-item{
        margin: 30px;
        position: relative;
        width: calc(100% / 2);
        &:last-child{
          margin-left: 0;
        }
        .item-left{
          width: 100px;
          height: 100px;
          border-radius: 4px;
          background: rgb(235,247,255);
          text-align: center;
          font-size: 18px;
          margin-right: 10px;
          font-weight: bold;
          display: flex;
          align-items: center;
        }
        .item-right{
          flex: 1;
          height: 100px;
          .name{
            font-size: 20px;
            color: #000;
            font-weight: bold;
          }
          .phone{
            color: #000;
            font-size: 16px;
          }
          .address{
            color: #999;
          }
        }
        .change-address{
          position: absolute;
          left: 0;
          cursor: pointer;
          bottom: -20px;
          color: #0b83f3;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>